import $ from 'jquery';
import {isEditable} from '../editor';

$.fn.DataTable.Api.register('cell().editable()', function () {
	return isEditable(this.column(this.node()), this.row(this.node()).data());
});


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/api/cellExtensions.js